import React, { useEffect, useState } from "react"
import { Button, Col, Form, Row, Table } from "react-bootstrap"
import { useNavigate, useParams } from "react-router-dom"
import Navbar from "../../../../Components/Navbar/Navbar"
import trash from "./../../../../Assets/Images/trash.png"
import Select from "react-select"
import { Select as SearchBox } from "antd"
import "../../PurchaseOrders/PurchaseOrders.css"
import Upload from "antd/es/upload/Upload"
import {
  getAllSuppliers,
  searchSupplier,
} from "../../../../Helpers/apiCalls/suppliersApi"
import { getAllForwarders } from "../../../../Helpers/apiCalls/forwardersApi"
import Modal from "antd/es/modal/Modal"
import {
  capitalizeFirstLetter,
  numberFormat,
  refreshPage,
  toastStyle,
  TokenExpiry,
  getTodayDateISO,
  getTodayDateISOFormat,
  antdesignSelectStyle,
} from "../../../../Helpers/Utils/Common"
import toast from "react-hot-toast"
import {
  createSuppliesExpense,
  editSuppliesExpense,
  getAllBranches,
  getSingleSuppliesExpense,
  approveSuppliesExpense,
  deleteSeAttachment,
} from "../../../../Helpers/apiCalls/Purchases/suppliesExpensesApi"
import InputError from "../../../../Components/InputError/InputError"
import AddModal from "../../../../Components/Modals/AddModal"
import {
  validateAddSO,
  validateSuppliesExpenseItems,
} from "../../../../Helpers/Validation/Purchase/SuppliersOrderValidation"
import { validateVendors } from "../../../../Helpers/Validation/Manage/VendorsValidation"
import { getAllEmployees } from "../../../../Helpers/apiCalls/employeesApi"
import ReactLoading from "react-loading"
import upload from "../../../../Assets/Images/upload.png"
import FileExceedModal from "../../../../Components/Modals/FileExceedModal"
import Compressor from "compressorjs"
import noDataImg from "../../../../Assets/Images/no-data-img.png"
import Footer from "../../../../Components/Footer/Footer"

function FormSuppliesExpenses({ add, edit }) {
  const { Dragger } = Upload
  const [isSaveClicked, setIsSaveClicked] = useState(false)
  const [isSubmitClicked, setIsSubmitClicked] = useState(false)
  const [addVendorIsSaveClicked, setAddVendorIsSaveClicked] = useState(false)
  const [prevAttachments, setPrevAttachments] = useState([])
  const [showFileExceedModal, setShowFileExceedModal] = useState(false)
  let navigate = useNavigate()
  let { id, type } = useParams()
  const [employees, setEmployees] = useState([])
  async function fetchEmployees() {
    setEmployees([])
    const response = await getAllEmployees()
    let result = response.data.data.map((data) => {
      var _middleName = data.middle_name || ""
      return {
        value: data.id,
        label: data.first_name + " " + _middleName + " " + data.last_name,
        name: "requisitioner",
      }
    })
    setEmployees(result)
  }
  const [itemError, setItemError] = useState({})
  const [supplierDetails, setSupplierDetails] = useState({
    trade_name: "",
    trade_address: "",
    bir_name: "",
    bir_address: "",
    tin: "",
    terms: "",
    requirements: "",
    phone_no: "",
    email: "",
    contact_person: "",
    bank_primary: "",
    bank_alternate: "",
    payee: "",
  })
  const typeOptions = [
    {
      id: 1,
      name: "type",
      value: "Transportation",
      label: "Transportation",
    },
    {
      id: 2,
      name: "type",
      value: "Kiosk construction",
      label: "Kiosk Construction",
    },
    {
      id: 3,
      name: "type",
      value: "Office supplies",
      label: "Office Supplies",
    },
    {
      id: 4,
      name: "type",
      value: "Store supplies",
      label: "Store Supplies",
    },
    {
      id: 5,
      name: "type",
      value: "Rental",
      label: "Rental",
    },
    {
      id: 6,
      name: "type",
      value: "CUSA + Aircon",
      label: "CUSA + Aircon",
    },
    {
      id: 7,
      name: "type",
      value: "Salaries + 13th Month",
      label: "Salaries + 13th Month",
    },
    {
      id: 8,
      name: "type",
      value: "Benefits - Employer Share",
      label: "Benefits - Employer Share",
    },
    {
      id: 9,
      name: "type",
      value: "Professional Fees",
      label: "Professional Fees",
    },
    {
      id: 10,
      name: "type",
      value: "Repairs and Maintenance",
      label: "Repairs and Maintenance",
    },
    {
      id: 11,
      name: "type",
      value: "Communication",
      label: "Communication",
    },
    {
      id: 12,
      name: "type",
      value: "Insurance",
      label: "Insurance",
    },
    {
      id: 13,
      name: "type",
      value: "Pest Control",
      label: "Pest Control",
    },
    {
      id: 14,
      name: "type",
      value: "Logistics",
      label: "Logistics",
    },
    {
      id: 15,
      name: "type",
      value: "Rental - Payable from Sales",
      label: "Rental - Payable from Sales",
    },
    {
      id: 16,
      name: "type",
      value: "Marketing",
      label: "Marketing",
    },
    {
      id: 17,
      name: "type",
      value: "Permits & Liscense Renewal",
      label: "Permits & Liscense Renewal",
    },
    {
      id: 18,
      name: "type",
      value: "Operating Supplies",
      label: "Operating Supplies",
    },
    {
      id: 19,
      name: "type",
      value: "Others",
      label: "Others",
    },
    {
      id: 20,
      name: "type",
      value: "Water",
      label: "Water",
    },
    {
      id: 21,
      name: "type",
      value: "Electricity",
      label: "Electricity",
    },
    {
      id: 22,
      name: "type",
      value: "Taxes",
      label: "Taxes",
    },
    {
      id: 23,
      name: "type",
      value: "Refund",
      label: "Refund",
    },
    {
      id: 24,
      name: "type",
      value: "Transportation/Delivery Expenses",
      label: "Transportation/Delivery Expenses",
    },
    {
      id: 25,
      name: "type",
      value: "Rent",
      label: "Rent",
    },
    {
      id: 26,
      name: "type",
      value: "Utilities Expenses",
      label: "Utilities Expenses",
    },
    {
      id: 27,
      name: "type",
      value: "Salaries and Wages",
      label: "Salaries and Wages",
    },
    {
      id: 28,
      name: "type",
      value: "Professional and Business Fees",
      label: "Professional and Business Fees",
    },
    {
      id: 29,
      name: "type",
      value: "Advertisement/Marketing Fund",
      label: "Advertisement/Marketing Fund",
    },
    {
      id: 30,
      name: "type",
      value: "Miscellaneous expenses",
      label: "Miscellaneous expenses",
    },
    {
      id: 31,
      name: "type",
      value: "Taxes and Licenses",
      label: "Taxes and Licenses",
    },
    {
      id: 32,
      name: "type",
      value: "Benefits and Loans",
      label: "Benefits and Loans",
    },
  ]

  const [showAddSupplierModal, setShowAddSupplierModal] = useState(false)
  const handleShowAddSupplierModal = () => setShowAddSupplierModal(true)
  const handleCloseAddSupplierModal = () => {
    setShowAddSupplierModal(false)
  }
  const [inactive, setInactive] = useState(true)
  const [showLoader, setShowLoader] = useState(false)
  const [grandTotal, setGrandTotal] = useState("0")
  const [branches, setBranches] = useState([])
  const [branchList, setBranchList] = useState([])
  const [suppliers, setSuppliers] = useState([])
  const [forwarders, setForwarders] = useState([])
  const [newSE, setNewSE] = useState({
    requisitioner: "",
    supplier_id: "",
    invoice_no: "",
    branch_id: "",
    forwarder_id: "",
    forwarder_contact_person: "",
    type: "",
    supplies_expense_date: add ? getTodayDateISO() : "",
    delivery_date: new Date().toLocaleDateString("en-CA"),
    delivery_address:
      "Tacloban City Ice Plant, 164 Justice Romualdez St. Tacloban City, Leyte",
    remarks: "",
    grand_total: 0,
    is_save: "",
    declared_value: 0,
  })
  const [items, setItems] = useState([
    {
      name: "",
      qty: "1",
      unit: "",
      price: "0",
      type: "",
      amount: "0",
      total: "0",
      remarks: "",
    },
    {
      name: "",
      qty: "1",
      unit: "",
      price: "0",
      type: "",
      amount: "0",
      total: "0",
      remarks: "",
    },
    {
      name: "",
      qty: "1",
      unit: "",
      price: "0",
      type: "",
      amount: "0",
      total: "0",
      remarks: "",
    },
  ])
  const [supplierValue, setSupplierValue] = useState({
    name: "supplier_id",
    label: "",
    value: "",
  })
  const [forwardersValue, setForwardersValue] = useState({
    name: "forwarder_id",
    label: "",
    value: "",
  })
  const [requisitionerValue, setRequisitionerValue] = useState({
    name: "requisitioner",
    label: "",
    value: "",
  })
  const [typeValue, setTypeValue] = useState({
    name: "type",
    label: "Select Type...",
    value: "",
  })
  const [branchValue, setBranchValue] = useState({
    name: "branch_id",
    label: "",
    value: "",
  })

  const [isError, setIsError] = useState({
    supplier_id: false,
    purchase_date: false,
    delivery_date: false,
    requisitioner: false,
    delivery_address: false,
    type: false,
    SEItems: false,
  })

  const [file, setFile] = useState("")
  const [fileList, setFileList] = useState([])
  const [preview, setPreview] = useState(false)
  const [previewFile, setPreviewFile] = useState("")

  async function deleteAttachment(selectedFile) {
    const response = await deleteSeAttachment({
      supplies_expense_id: id,
      attachment_id: selectedFile.id,
    })
  }

  const handleRemove = (selectedFile) => {
    var newlist = fileList.filter((file) => {
      return selectedFile.uid !== file.uid
    })
    setFileList(newlist)
  }

  const handleBeforeUpload = (file) => {
    if (file.size > 2000000) {
      setShowFileExceedModal(true)
    } else {
      //COMPRESSING FILE
      new Compressor(file, {
        quality: 0.6,
        success: (compressedResult) => {
          setFileList([...fileList, compressedResult])
        },
      })
    }
    return false
  }

  function handleRemoveItemAttachment(url) {
    var newList = prevAttachments.filter((data) => {
      return data.file_url !== url
    })
    setPrevAttachments(newList)
    setPreview(false)
  }

  function AddItem() {
    const newItem = {
      name: "",
      qty: 1,
      unit: "",
      price: 0,
      type: "",
      amount: 0,
      remarks: "",
    }
    setItems((prevItems) => [...prevItems, newItem])
  }

  function renderTable() {
    return (
      <Table>
        <thead>
          <tr>
            <th>Item</th>
            <th>Quantity</th>
            <th>Unit</th>
            <th>Unit Price</th>
            <th>Amount</th>
            <th>Remarks</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {items?.map((item, index) => {
            return (
              <tr key={item.id}>
                <td>
                  <Form.Control
                    type="text"
                    name="name"
                    placeholder="Description"
                    defaultValue={item.name}
                    onChange={(e) => handleItemChange(e, index)}
                  />
                  {itemError[index] && itemError[index].name && (
                    <div className="validity-error callout bottom">
                      {itemError[index].name}
                    </div>
                  )}
                </td>
                <td>
                  <Form.Control
                    type="text"
                    name="qty"
                    defaultValue={item.qty}
                    onChange={(e) => handleItemChange(e, index)}
                  />
                  {itemError[index] && itemError[index].qty && (
                    <div className="validity-error callout bottom">
                      {itemError[index].qty}
                    </div>
                  )}
                </td>
                <td>
                  <Form.Control
                    type="text"
                    name="unit"
                    defaultValue={item.unit}
                    onChange={(e) => handleItemChange(e, index)}
                  />
                  {itemError[index] && itemError[index].unit && (
                    <div className="validity-error callout bottom">
                      {itemError[index].unit}
                    </div>
                  )}
                </td>
                <td className="row align-contents">
                  <Col xs={2} className="align-middle">
                    PHP
                  </Col>
                  <Col>
                    <Form.Control
                      type="text"
                      name="price"
                      defaultValue={item.price}
                      onChange={(e) => handleItemChange(e, index)}
                    />
                    {itemError[index] && itemError[index].price && (
                      <div className="validity-error callout bottom">
                        {itemError[index].price}
                      </div>
                    )}
                  </Col>
                </td>
                <td>
                  {showLoader
                    ? null
                    : item.qty && item.price
                    ? "PHP " +
                      numberFormat(
                        parseFloat(item.qty) * parseFloat(item.price)
                      )
                    : "PHP 0.00"}
                </td>
                <td>
                  <Form.Control
                    type="text"
                    name="remarks"
                    defaultValue={item.remarks}
                    onChange={(e) => handleItemChange(e, index)}
                  />
                </td>
                <td>
                  <img
                    src={trash}
                    onClick={() => handleRemoveItem(index)}
                    className="cursor-pointer"
                    alt=""
                  />
                </td>
              </tr>
            )
          })}
          {/* <tr>
            <td colSpan={3}></td>
            <td colSpan={2} align="center" className="print-table-footer-label grand-label">
              GRAND TOTAL
            </td>
            <td align="center" className="print-table-footer-data grand-label">
              {showLoader
                ? null
                : grandTotal
                ? "PHP " + numberFormat(grandTotal)
                : "PHP 0.00"}
            </td>
            <td></td>
          </tr> */}
        </tbody>
      </Table>
    )
  }

  function handleItemChange(e, id) {
    const { name, value } = e.target

    if (name === "qty" || name === "price") {
      setShowLoader(true)
    }

    items.map((item, index) => {
      item.total = parseFloat(item.total)
      if (index === id) {
        item[name] = value
        if (value === "") item[name] = "0"
        item.total = parseFloat(item.qty) * parseFloat(item.price)
      }
    })

    var total = 0
    for (var i = 0; i < items.length; i++) {
      total += items[i].total
    }
    setGrandTotal(total)
    setItems(items)
    setNewSE(newSE)

    setTimeout(() => setShowLoader(false), 1)
  }

  function handleRemoveItem(id) {
    setShowLoader(true)
    const rowId = id
    const newItemList = [...items]
    newItemList.splice(rowId, 1)
    setItems(newItemList)

    setGrandTotal(
      newItemList.map((item) => item.total).reduce((a, b) => a + b, 0)
    )

    setTimeout(() => setShowLoader(false), 1)
  }

  function handleSelectChange(e, type) {
    const newList = newSE
    newList[e.name] = e.value
    setNewSE(newList)

    if (type === "supplier_id") {
      var supplier_name = suppliers.filter((data) => {
        return data.value === e
      })
      setNewSE((prev) => {
        return {
          ...prev,
          supplier_id: e,
          supplier_id_value: {
            label: supplier_name[0].label,
            value: supplier_name[0].value,
          },
        }
      })
    } else {
      if (e.name === "branch_id") {
        setBranchValue({ name: e.name, label: e.label, value: e.value })
        var address = branchList.filter((data) => data.id === e.value)[0]
          .address
        setNewSE({
          ...newSE,
          delivery_address: address !== null ? address : "",
          branch_id: e.value,
        })
      } else if (e.name === "type") {
        setTypeValue({ name: e.name, label: e.label, value: e.value })
        setNewSE({
          ...newSE,
          type: e.value,
        })
      } else if (e.name === "forwarder_id") {
        setForwardersValue({
          name: e.name,
          label: e.label,
          value: e.value,
        })
        setNewSE({
          ...newSE,
          forwarder_contact_person: e.phone_no,
        })
      } else if (e.name === "requisitioner") {
        setRequisitionerValue({
          name: e.name,
          label: e.label,
          value: e.value,
        })
        setNewSE({
          ...newSE,
          requisitioner: e.value,
        })
      }
    }
  }
  function handleSEChange(e) {
    const { name, value } = e.target
    setNewSE((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  function handleSubmit() {
    if (add) saveNewSE()
    if (edit) editSE()
  }

  /** GET API - Branches **/
  async function fetchBranches() {
    const response = await getAllBranches()

    if (response.data) {
      var data = response.data.data
      data.map((branch) => {
        var info = {}

        info.name = "branch_id"
        info.label = branch.name
        info.value = branch.id
        branchList.push(branch)
        setBranches((prev) => [...prev, info])
      })
    }
  }

  /** GET API - Suppliers **/
  const handleSearchSupplier = (newValue) => {
    if (newValue.length > 2) {
      //if length of the input is greater than 3, it will call the search api
      fetchSuppliers(newValue, setSuppliers)
    }
  }

  // new api for searching items
  async function fetchSuppliers(value, setSuppliers) {
    setSuppliers([])
    const response = await searchSupplier({ name: value })
    if (response.response) {
      var suppliers = response.response.data.map((data) => {
        var info = data
        info.label = data.trade_name
        info.value = data.id
        info.label = data.trade_name
        info.contact_person = data.contact_person
        info.phone_no = data.phone_no

        return info
      })
      setSuppliers(suppliers)
    } else {
      response.error?.data?.messages.map((data) => {
        return toast.error(data, {
          style: toastStyle(),
        })
      })
    }
  }

  async function fetchForwarders() {
    setForwarders([])

    const response = await getAllForwarders()
    if (response.data) {
      var forwarders = response.data.data.sort((a, b) =>
        a.name > b.name ? 1 : b.name > a.name ? -1 : 0
      )

      forwarders.map((forwarder) => {
        var info = {}

        info.name = "forwarder_id"
        info.label = forwarder.name
        info.value = forwarder.id
        info.forwarder_contact_person = forwarder.contact_person
        info.phone_no = forwarder.phone_no

        setForwarders((prev) => [...prev, info])
      })
    }
  }

  /** POST API - Save new supplies expense **/
  async function saveNewSE() {
    // var hasItems = items.length > 0 ? true : false;
    // var hasItemContent = hasItems
    //   ? items[0].qty != "" &&
    //     items[0].unit != "" &&
    //     items[0].qty != "0" &&
    //     items[0].unit != 0
    //   : false;
    // isError["SEItems"] = !(hasItems && hasItemContent);
    // if (isSaveClicked || isSubmitClicked) {
    //   return;
    // }
    if (newSE.is_save === 0) {
      var errors = validateSuppliesExpenseItems(items)
      setItemError(errors)
      if (
        validateAddSO(newSE, items, setIsError) &&
        Object.keys(errors).length === 0
      ) {
        setIsSubmitClicked(true)
        newSE.attachments = fileList
        newSE.status = "for_approval"
        newSE.grand_total = grandTotal
        const response = await createSuppliesExpense(newSE, items)

        if (response.data) {
          toast.success(response.data.message, {
            style: toastStyle(),
          })
          setTimeout(() => {
            navigate(
              "/suppliesexpenses/review/" + response.data.supplies_expense_id
            )
          }, 1000)
        } else {
          response.error?.response?.data?.messages.map((data) => {
            return toast.error(data)
          })
          // setTimeout(() => refreshPage(), 1000);
        }
        setIsSubmitClicked(false)
      }
    } else {
      var errors = validateSuppliesExpenseItems(items)
      setItemError(errors)
      if (
        validateAddSO(newSE, items, setIsError) &&
        Object.keys(errors).length === 0
      ) {
        setIsSaveClicked(true)
        newSE.attachments = fileList
        newSE.status = "pending"
        newSE.grand_total = grandTotal
        const response = await createSuppliesExpense(newSE, items)

        if (response.data) {
          toast.success(response.data.message, {
            style: toastStyle(),
          })
          setTimeout(() => {
            navigate("/suppliesexpenses")
            refreshPage()
          }, 1000)
        } else {
          response.error?.response?.data?.messages.map((data) => {
            return toast.error(data)
          })
          // setTimeout(() => refreshPage(), 1000);
        }
      }
      setIsSubmitClicked(false)
    }
  }

  /** POST API - Edit old supplies expense **/
  async function editSE() {
    newSE.attachments = fileList
    newSE.status = "for_approval"
    // var hasItems = items.length > 0 ? true : false;
    // var hasItemContent = hasItems
    //   ? items[0].qty != "" &&
    //     items[0].unit != "" &&
    //     items[0].qty != "0" &&
    //     items[0].unit != 0
    //   : false;
    // isError["SEItems"] = !(hasItems && hasItemContent);
    // if (isSaveClicked || isSubmitClicked) {
    //   return;
    // }
    if (newSE.is_save === 0) {
      newSE.status = "for_approval"
      newSE.grand_total = grandTotal
      newSE.prev_files = prevAttachments
      var errors = validateSuppliesExpenseItems(items)
      setItemError(errors)
      if (
        validateAddSO(newSE, items, setIsError) &&
        Object.keys(errors).length === 0
      ) {
        setIsSaveClicked(true)
        setIsSubmitClicked(true)
        const response = await editSuppliesExpense(newSE, items, id)
        if (response.data) {
          toast.success("Supplies Expenses Updated Successfully!", {
            style: toastStyle(),
          })
          setTimeout(() => {
            navigate("/suppliesexpenses/review/" + id)
          }, 1000)
          // const response = await approveSuppliesExpense(id, "for_approval");
          // if (response.data) {
          //   toast.success("Supplies Expenses Updated Successfully!", {
          //     style: toastStyle(),
          //   });
          //   setTimeout(() => {
          //     navigate("/suppliesexpenses/review/" + id);
          //   }, 1000);
          // } else {
          //   toast.error("Error Updating Supplies Expenses", {
          //     style: toastStyle(),
          //   });
          // }
        } else {
          toast.error("Error Updating Supplies Expenses", {
            style: toastStyle(),
          })
          // setTimeout(() => refreshPage(), 1000);
        }
        setIsSaveClicked(false)
        setIsSubmitClicked(false)
      } else {
        alert("validation error")
      }
    } else {
      newSE.status = "pending"
      newSE.grand_total = grandTotal
      newSE.prev_files = prevAttachments
      const response = await editSuppliesExpense(newSE, items, id)
      if (response.data) {
        toast.success("Supplies Expenses Updated Successfully!", {
          style: toastStyle(),
        })
        setTimeout(() => {
          navigate("/suppliesexpenses")
          refreshPage()
        }, 1000)
      } else {
        toast.error("Error Updating Supplies Expenses", {
          style: toastStyle(),
        })
        setTimeout(() => refreshPage(), 1000)
      }
    }
  }

  /** GET API - Get single supplies expense **/
  async function fetchSingleSuppliesExpense(id) {
    const response = await getSingleSuppliesExpense(id)
    if (response.data) {
      var data = response.data.data[0]
      data.delivery_date = getTodayDateISOFormat(data.delivery_date)
      data.supplies_expense_date = getTodayDateISOFormat(
        data.supplies_expense_date
      )
      data.supplier_id_value = {
        label: data.supplier_trade_name,
        value: data.supplier_id,
      }

      setNewSE(data)
      setGrandTotal(data.grand_total)
      setItems(data.supplies_expense_items)
      setSupplierValue({
        name: data.supplier_trade_name ? "supplier_id" : "vendor_id",
        label: data.supplier_trade_name || data.vendor_trade_name,
        value: data.supplier_id || data.vendor_id,
      })
      setRequisitionerValue({
        name: "requisitioner",
        label: data.requisitioner_name,
        value: data.requisitioner,
      })
      setBranchValue({
        name: "branch_id",
        label: data.branch_name,
        value: data.branch_id,
      })
      setForwardersValue({
        name: "forwarder_id",
        label: data.forwarder_name,
        value: data.forwarder_id,
      })
      setTypeValue({
        name: "type",
        label: capitalizeFirstLetter(data.type),
        value: data.type,
      })
      setPrevAttachments(data.supplies_expense_attachments)
    }
  }

  function handleAddSupplierClick() {
    window.open("/suppliers", "_blank")
  }

  useEffect(() => {
    if (edit) {
      fetchSingleSuppliesExpense(id)
    }
    fetchBranches()
    fetchForwarders()
    fetchEmployees()
  }, [])

  useEffect(() => {}, [newSE])

  //DISABLE SCROLL FUNCTION
  function limitScroll() {
    var numericInputs = document.querySelectorAll(".numeric-input")
    numericInputs.forEach(function (input) {
      input.addEventListener("wheel", function (e) {
        e.preventDefault()
      })
    })
  }
  limitScroll()

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"SUPPLIES"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <Row className="mb-4">
          <Col xs={12} lg={7}>
            <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
              {add && "ADD SUPPLIES EXPENSE"}
              {edit && "EDIT SUPPLIES EXPENSE"}{" "}
            </h1>
          </Col>
        </Row>

        {/* content */}

        <div className="edit-form">
          <Row className="mb-2">
            <Col xs={12} lg={6}>
              <span className="edit-label">
                Supplier Name <label className="badge-required">{` *`}</label>
              </span>
              <SearchBox
                showSearch
                value={newSE.supplier_id_value}
                placeholder={"Search Supplier..."}
                className="react-select-container w-100"
                dropdownClassName="z-large antdesign-custom-dropdown"
                style={antdesignSelectStyle}
                defaultActiveFirstOption={false}
                suffixIcon={null}
                filterOption={false}
                onSearch={handleSearchSupplier}
                onChange={(e) => handleSelectChange(e, "supplier_id")}
                notFoundContent={null}
                options={(suppliers || []).map((d) => ({
                  value: d.value,
                  label: d.label,
                }))}
              />
              {/* <Select
                className="react-select-container"
                classNamePrefix="react-select"
                placeholder="Select Supplier..."
                value={supplierValue}
                options={suppliers}
                onChange={(e) => handleSelectChange(e)}
              /> */}
              <InputError
                isValid={isError.supplierName}
                message={"Supplier Name is required"}
              />
              <div className="d-flex justify-content-end">
                <span className="edit-label" style={{ color: "#df1227" }}>
                  Supplier Not Found?{" "}
                  <a
                    onClick={handleAddSupplierClick}
                    className="add-supplier-label"
                  >
                    Click here to add supplier
                  </a>
                </span>
              </div>
            </Col>

            <Col xs={12} lg={3} className="mt-3 mt-lg-0">
              <span className="edit-label">
                Purchase Date <label className="badge-required">{` *`}</label>
              </span>
              <Form.Control
                className="nc-modal-custom-text"
                type="date"
                name="supplies_expense_date"
                defaultValue={newSE.supplies_expense_date}
                onChange={(e) => handleSEChange(e)}
              />
              <InputError
                isValid={isError.purchaseDate}
                message={"Purchase date is required"}
              />
            </Col>

            <Col xs={12} lg={3} className="mt-4 mt-lg-0">
              <span className="edit-label">
                Invoice No.{" "}
                {/* <label className="badge-required">{` *`}</label> */}
              </span>
              <Form.Control
                type="text"
                name="invoice_no"
                className="nc-modal-custom-input"
                value={newSE.invoice_no}
                onChange={(e) => handleSEChange(e)}
              />
            </Col>
          </Row>
          <Row className="mb-2">
            <Col xs={12} lg={4}>
              <span className="edit-label">
                Branch
                <label className="badge-required">{` *`}</label>{" "}
              </span>
              <Select
                className="react-select-container"
                classNamePrefix="react-select"
                placeholder="Select Branch..."
                value={branchValue}
                options={branches}
                onChange={(e) => handleSelectChange(e)}
              />
              <InputError
                isValid={isError.branch_id}
                message={"Branch is required"}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-4 mt-lg-0">
              <span className="edit-label">Forwarder</span>
              <Select
                className="react-select-container"
                classNamePrefix="react-select"
                placeholder="Select Forwarder..."
                value={forwardersValue}
                options={forwarders}
                onChange={(e) => handleSelectChange(e)}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-4 mt-lg-0">
              <span className="edit-label">Forwarder Contact No</span>
              <Form.Control
                className="nc-modal-custom-input"
                type="text"
                name="forwarder_contact_person"
                value={newSE.forwarder_contact_person}
                onChange={(e) => handleSEChange(e)}
              />
            </Col>
          </Row>
          <Row className="mb-3">
            <Col xs={12} lg={4}>
              <span className="edit-label">
                Requested by <label className="badge-required">{` *`}</label>
              </span>
              <Select
                className="react-select-container"
                classNamePrefix="react-select"
                placeholder="Select requisitioner..."
                value={requisitionerValue}
                options={employees}
                onChange={(e) => handleSelectChange(e)}
              />
              <InputError
                isValid={isError.requisitioner}
                message={"Requisitioner is required"}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-4 mt-lg-0">
              <span className="edit-label">
                Type <label className="badge-required">{` *`}</label>
              </span>
              <Select
                className="react-select-container"
                classNamePrefix="react-select"
                placeholder="Select type..."
                value={typeValue}
                options={typeOptions.sort((a, b) =>
                  a.value > b.value ? 1 : b.value > a.value ? -1 : 0
                )}
                onChange={(e) => handleSelectChange(e)}
              />
              <InputError isValid={isError.type} message={"Type is required"} />
            </Col>
            <Col xs={12} lg={4} className="mt-4 mt-lg-0">
              <span className="edit-label">Declared Value</span>
              <Form.Control
                className="nc-modal-custom-input"
                type="text"
                name="declared_value"
                value={newSE.declared_value}
                onChange={(e) => handleSEChange(e)}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <span className="edit-label">
                Delivery Address{" "}
                <label className="badge-required">{` *`}</label>
              </span>
              <Form.Control
                type="text"
                name="delivery_address"
                className="nc-modal-custom-input"
                value={newSE.delivery_address}
                onChange={(e) => handleSEChange(e)}
              />
              <InputError
                isValid={isError.deliveryAddress}
                message={"delivery address is required"}
              />
            </Col>
          </Row>

          <Row className="mt-4 pt-3">
            <Col>
              <span className="edit-label mb-2">
                Particulars
                <label className="badge-required">{` *`}</label>
              </span>
              <div className="edit-purchased-items">
                {items?.length === 0 ? (
                  <span>No Purchased Item Found!</span>
                ) : (
                  renderTable()
                )}
                <InputError
                  isValid={isError.itemList}
                  message={"You must add at least 1 item is required"}
                />
              </div>
            </Col>
          </Row>
          <Row className="pt-3 pb-3 PO-add-item">
            <Col>
              <Button type="button" onClick={() => AddItem()}>
                Add Item
              </Button>
            </Col>
          </Row>
          <Row className="align-right py-2">
            <Col xs={8} className="text-end">
              <span className="edit-label color-gray grand-total-text">
                Grand Total
              </span>
            </Col>
            <Col xs={1} className="text-end">
              <span className="edit-label align-middle grand-total-text">
                PHP
              </span>
            </Col>
            <Col xs={3} className="text-end">
              <span className="edit-label align-middle grand-total-text">
                {numberFormat(grandTotal)}
              </span>
            </Col>
          </Row>

          <Row className="mb-2">
            <Col>
              <span className="edit-label">
                Remarks
                <span className="edit-optional px-2">(Optional)</span>
              </span>
              <Form.Control
                className="nc-modal-custom-input"
                as="textarea"
                name="remarks"
                value={newSE.remarks}
                onChange={(e) => handleSEChange(e)}
              />
            </Col>
          </Row>

          {edit && (
            <>
              <div className="mt-4 noPrint mx-3">
                <Row className="review-data mb-2">FILE ATTACHMENTS</Row>
                <Row className="">
                  {prevAttachments &&
                    prevAttachments.map((attachment) => (
                      <Col
                        xs={1}
                        onClick={() => {
                          setPreviewFile(attachment.file_url)
                          setPreview(true)
                        }}
                        className="cursor-pointer preview-container"
                      >
                        <img
                          src={attachment.file_url}
                          className="img-preview"
                        />
                      </Col>
                    ))}
                  {!prevAttachments ||
                    (prevAttachments.length === 0 && (
                      <Col xs={1}>
                        <div className="no-data-cont d-flex justify-content-left preview-container">
                          <img
                            src={noDataImg}
                            alt="no data found"
                            className="img-preview"
                          />
                        </div>
                      </Col>
                    ))}
                </Row>
              </div>
            </>
          )}
          <Row className="mt-4 mb-2">
            <Col>
              <Dragger
                fileList={fileList}
                onRemove={handleRemove}
                beforeUpload={handleBeforeUpload}
                multiple={false}
                listType="picture"
                progress={{ showInfo: true }}
              >
                <img src={upload} className="cursor-pointer" />
                <p className="ant-upload-text">
                  Click or drag file to this area to upload
                </p>
              </Dragger>
            </Col>
          </Row>

          <div className="d-flex justify-content-end pt-5 pb-3">
            <button
              type="button"
              className="button-secondary me-3"
              onClick={() => navigate("/suppliesexpenses")}
            >
              Close
            </button>
            {!isSaveClicked && type !== "for_approval" && (
              <button
                type="button"
                className="button-tertiary me-3"
                onClick={() => {
                  newSE["is_save"] = 1
                  handleSubmit()
                }}
              >
                Save
              </button>
            )}
            {isSaveClicked && type !== "for_approval" && (
              <div className="button-tertiary me-3 d-flex justify-content-center">
                <ReactLoading
                  type="bubbles"
                  color="#FFFFFF"
                  height={20}
                  width={25}
                />
              </div>
            )}
            {!isSubmitClicked && (
              <button
                type="button"
                className="button-primary"
                onClick={() => {
                  newSE["is_save"] = 0
                  handleSubmit()
                }}
              >
                {type === "for_approval" ? "Done" : "Submit"}
              </button>
            )}
            {isSubmitClicked && (
              <div className="button-primary d-flex justify-content-center">
                <ReactLoading
                  type="bubbles"
                  color="#FFFFFF"
                  height={20}
                  width={25}
                />
              </div>
            )}
          </div>
        </div>
      </div>
      <Modal
        open={preview}
        title={""}
        footer={null}
        onCancel={() => setPreview(false)}
      >
        <Row className="justify-content-center">
          <img
            alt="example"
            style={{
              width: "100%",
            }}
            src={previewFile}
          />
          <div className="mt-2 d-flex justify-content-center">
            <img
              src={trash}
              alt="trash"
              onClick={() => handleRemoveItemAttachment(previewFile)}
              className="cursor-pointer"
            />
          </div>
        </Row>
      </Modal>
      <FileExceedModal
        show={showFileExceedModal}
        onHide={() => setShowFileExceedModal(false)}
        size="2MB"
      />
      <Footer />
    </div>
  )
}

FormSuppliesExpenses.defaultProps = {
  add: false,
  edit: false,
  defaultValues: {},
}

export default FormSuppliesExpenses
